module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor17-069c2520c23ed609be1a37e1c0499a52.png";